import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ErrorBoundary } from "@/components/feedback/ErrorBoundary";
import { AppRouter } from "@/app/AppRouter";
import { AutoPushEnrollment } from "@/components/notifications/AutoPushEnrollment";

export function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <AutoPushEnrollment />
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}
